module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_vm._v("请确认以下信息，然后提交订单")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "same_module consignee_adr wrap"
  }, [_c('div', {
    staticClass: "same_module_rel"
  }, [_c('div', {
    staticClass: "mod_rel_head clearfix"
  }, [_c('span', {
    staticClass: "mr_tit"
  }, [_vm._v("收货信息")]), _vm._v(" "), _c('a', {
    staticClass: "mr_ctrlbtn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cAddAddress.apply(null, arguments)
      }
    }
  }, [_vm._v("新建地址")])]), _vm._v(" "), _c('div', {
    staticClass: "consign_rel_cont"
  }, [_c('ul', {
    staticClass: "clearfix",
    class: [_vm.isActive ? 'changes' : 'chang'],
    attrs: {
      "id": "consignee-list"
    }
  }, [_vm._l((_vm.addressList), function(item, index) {
    return _c('li', {
      key: item.addressId,
      staticClass: "consignee-item item-selected",
      class: {
        cur: _vm.currentIndex === index
      },
      attrs: {
        "id": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.checkAddre(item.addressId, index, item.countyName, item)
        }
      }
    }, [_c('div', {
      staticClass: "total_info clearfix op-btns",
      attrs: {
        "id": "consignee_index_div_-2128470671"
      }
    }, [_c('i', {
      staticClass: "fl sprite_odr adr_icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "fl tot_name"
    }, [_vm._v(_vm._s(item.consigneeName) + " " + _vm._s(item.province))]), _vm._v(" "), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.defaultAddress == 1),
        expression: "item.defaultAddress==1"
      }],
      staticClass: "init_adrs"
    }, [_vm._v("默认")])]), _vm._v(" "), _c('div', {
      staticClass: "detail_info"
    }, [_c('p', [_vm._v(_vm._s(item.consigneeName)), _c('span', {
      staticClass: "ml5"
    }, [_vm._v(_vm._s(item.mobile))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.province) + " " + _vm._s(item.city) + " " + _vm._s(item.region) + " " + _vm._s(item.countyName || ""))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.address))])]), _vm._v(" "), _c('div', {
      staticClass: "sprite_odr is_choose"
    })])
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "hidden_consignees_size",
      "value": "5"
    }
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isMoreAddr),
      expression: "isMoreAddr"
    }],
    staticClass: "cng_more",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function($event) {
        return _vm.showMoreAddr()
      }
    }
  }, [_c('span', [_vm._v("更多地址")]), _c('em', {
    class: [_vm.isActive ? 'sprite_odrs' : 'sprite_odr']
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.couponLimit > 0 || _vm.usedSelfShoppingPv > 0) && parseFloat(_vm.myCoupon)),
      expression: "(couponLimit>0||usedSelfShoppingPv>0) && parseFloat(myCoupon)"
    }],
    staticClass: "same_module consignee_adr wrap"
  }, [_c('div', {
    staticClass: "same_module_rel address"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sureEdit),
      expression: "!sureEdit"
    }]
  }, [_vm._v("请先填写收货人信息。")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sureEdit),
      expression: "sureEdit"
    }],
    staticClass: "way assets_rel_cont"
  }, [(_vm.couponLimit > 0 && parseFloat(_vm.myCoupon)) ? _c('li', {
    staticClass: "item assets_items"
  }, [_c('div', {
    staticClass: "assets_itms_info clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "aii_tiptxt"
  }, [_vm._v("当前使用现金券金额："), _c('strong', {
    staticStyle: {
      "color": "red",
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(parseFloat(_vm.couponLimit)))]), _vm._v("，\n                  可用现金券余额：¥" + _vm._s(_vm.myCoupon) + " ")]), _vm._v(" "), _c('label', {
    staticClass: "aii_chkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.couponUsed),
      expression: "couponUsed"
    }],
    attrs: {
      "type": "checkbox",
      "id": "coupon"
    },
    domProps: {
      "checked": Array.isArray(_vm.couponUsed) ? _vm._i(_vm.couponUsed, null) > -1 : (_vm.couponUsed)
    },
    on: {
      "click": _vm.clickCoupon,
      "change": function($event) {
        var $$a = _vm.couponUsed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.couponUsed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.couponUsed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.couponUsed = $$c
        }
      }
    }
  }), _vm._v(" "), _c('em', [_vm._v("使用")])]), _vm._v(" "), _c('span', {
    staticClass: "fr sp_totals"
  }, [_vm._v(" - ¥ " + _vm._s(parseFloat(_vm.couponLimit)))])])]) : _vm._e(), _vm._v(" "), (_vm.usedSelfShoppingPv > 0 && parseFloat(_vm.mySignRebate)) ? _c('li', {
    staticClass: "item assets_items"
  }, [_c('div', {
    staticClass: "assets_itms_info clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "aii_tiptxt"
  }, [_vm._v("当前使用自营购物积分："), _c('strong', {
    staticStyle: {
      "color": "red",
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.usedSelfShoppingPv))]), _vm._v("， 可用自营购物积分余额：¥" + _vm._s(_vm.mySignRebate) + "\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "aii_chkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selfShoppingPvFlag),
      expression: "selfShoppingPvFlag"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selfShoppingPvFlag) ? _vm._i(_vm.selfShoppingPvFlag, null) > -1 : (_vm.selfShoppingPvFlag)
    },
    on: {
      "click": _vm.clickSelfShoppingPv,
      "change": function($event) {
        var $$a = _vm.selfShoppingPvFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selfShoppingPvFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selfShoppingPvFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selfShoppingPvFlag = $$c
        }
      }
    }
  }), _vm._v(" "), _c('em', [_vm._v("使用")])]), _vm._v(" "), _c('span', {
    staticClass: "fr sp_totals"
  }, [_vm._v(" - ¥ " + _vm._s(_vm.usedSelfShoppingPv))])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "same_module list"
  }, [_c('div', {
    staticClass: "mod_rel_head clearfix"
  }, [_c('span', {
    staticClass: "mr_tit"
  }, [_vm._v("商品清单")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buyType === 1),
      expression: "buyType === 1"
    }],
    staticClass: "mr_ctrlbtn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cReturnCart.apply(null, arguments)
      }
    }
  }, [_vm._v("[返回购物车修改]")])]), _vm._v(" "), _vm._l((_vm.storeProduct), function(sItem, sIndex) {
    return _c('div', {
      key: sIndex,
      style: ('margin-top:' + (sIndex ? 100 : 10) + 'px;')
    }, [_c('div', {
      staticClass: "shopname"
    }, [_vm._v("店铺id：" + _vm._s(sItem.storeId) + " 店铺名称：" + _vm._s(sItem.storeName) + _vm._s(_vm.judge(sItem.sourceFlag)))]), _vm._v(" "), _c('table', {
      attrs: {
        "cellspacing": "0",
        "cellpadding": "3",
        "width": "100%"
      }
    }, [_c('tr', {
      staticClass: "thead"
    }, _vm._l((_vm.list_th), function(item) {
      return _c('th', {
        key: item
      }, [_vm._v(_vm._s(item))])
    }), 0), _vm._v(" "), _vm._l((sItem.brandProductList), function(brandProducts, brandId) {
      return [_vm._l((brandProducts), function(item) {
        return (item.isCheck) ? _c('tr', {
          key: item.goodsId
        }, [_c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.cGoods(item.goodsId)
            }
          }
        }, [_c('img', {
          attrs: {
            "src": item.imageDefault,
            "alt": "购物车商品海报"
          }
        })]), _vm._v(" "), _c('td', {
          staticClass: "name",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.cGoods(item.goodsId)
            }
          }
        }, [_vm._v(_vm._s(item.name || item.goodName))]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(item.disPrice > 0 ? _vm.returnFloat(item.disPrice || item.discountPrice) : '0.00'))]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(_vm.returnFloat(item.coupPrice || item.couponPrice)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.num))]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(_vm.returnFloat(item.num * (item.coupPrice || item.couponPrice))))])]) : _vm._e()
      }), _vm._v(" "), _c('tr', [_c('td', {
        staticStyle: {
          "overflow": "auto",
          "width": "100%",
          "padding": "0 5px"
        },
        attrs: {
          "colspan": "6"
        }
      }, [_c('div', {
        staticClass: "ways"
      }, [_c('span', {
        staticStyle: {
          "text-align": "center"
        }
      }, [_vm._v("配送方式：")]), _vm._v(" "), _vm._l((_vm.ways), function(wItem, wIndex) {
        return (_vm.currWay[sItem.storeId] && wItem.storeId == sItem.storeId && (!Number(brandId) || wItem.brandId == brandId)) ? _c('Select', {
          key: wItem.storeId + wIndex,
          staticStyle: {
            "width": "252px"
          },
          attrs: {
            "slot": "prepend"
          },
          slot: "prepend",
          model: {
            value: (_vm.currWay[sItem.storeId][brandId]),
            callback: function($$v) {
              _vm.$set(_vm.currWay[sItem.storeId], brandId, $$v)
            },
            expression: "currWay[sItem.storeId][brandId]"
          }
        }, _vm._l((wItem.shippingList), function(child, childIdx) {
          return _c('Option', {
            key: child.shipId,
            attrs: {
              "value": child.shipId
            },
            nativeOn: {
              "click": function($event) {
                return _vm.chooseWays(sIndex, brandId, childIdx)
              }
            }
          }, [_vm._v(_vm._s(child.shipName || child.shipDesc) + "\n                    ")])
        }), 1) : _vm._e()
      })], 2)])])]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "other"
    }, [_c('div', {
      staticClass: "all-price"
    }, [_c('span', [_vm._v("店铺总计：")]), _c('span', [_vm._v("￥"), _c('em', {
      staticStyle: {
        "color": "#4b4c4c",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.amount(sItem, _vm.postage[sIndex])))]), _vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "remark"
    }, [_c('span', [_vm._v("订单备注：")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.remark[sIndex]),
        expression: "remark[sIndex]"
      }],
      staticStyle: {
        "width": "378px",
        "height": "55px",
        "line-height": "20px",
        "margin-top": "5px",
        "resize": "none"
      },
      domProps: {
        "value": (_vm.remark[sIndex])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.remark, sIndex, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tip"
    }, [_vm._v("*请勿填写有关支付/收货/发票方面的信息，如有特殊需要请联系客服人员。")])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "time-order"
  }, [_c('div', {
    staticClass: "delivery-time"
  }, [_c('span', [_vm._v("送货时间：")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: (_vm.deliveryTime),
      callback: function($$v) {
        _vm.deliveryTime = $$v
      },
      expression: "deliveryTime"
    }
  }, [_c('Option', {
    attrs: {
      "value": "任意日期"
    }
  }, [_vm._v("任意日期")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "仅工作日"
    }
  }, [_vm._v("仅工作日")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "仅休息日"
    }
  }, [_vm._v("仅休息日")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "invoice"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice.need),
      expression: "invoice.need"
    }],
    attrs: {
      "type": "checkbox",
      "id": "invoice",
      "value": "invoice"
    },
    domProps: {
      "checked": Array.isArray(_vm.invoice.need) ? _vm._i(_vm.invoice.need, "invoice") > -1 : (_vm.invoice.need)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.invoice.need,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "invoice",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.invoice, "need", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.invoice, "need", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.invoice, "need", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "invoice"
    }
  }, [_vm._v("索取发票")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoice.need),
      expression: "invoice.need"
    }],
    staticClass: "content"
  }, [_c('div', [_c('span', [_vm._v("发票抬头")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice.raised),
      expression: "invoice.raised"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "One"
    },
    domProps: {
      "checked": _vm._q(_vm.invoice.raised, "One")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.invoice, "raised", "One")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("个人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice.raised),
      expression: "invoice.raised"
    }],
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "Two"
    },
    domProps: {
      "checked": _vm._q(_vm.invoice.raised, "Two")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.invoice, "raised", "Two")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "two"
    }
  }, [_vm._v("单位")]), _vm._v(" "), _c('Input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoice.raised === 'Two'),
      expression: "invoice.raised === 'Two'"
    }],
    staticClass: "info",
    model: {
      value: (_vm.invoice.title),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "title", $$v)
      },
      expression: "invoice.title"
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v("发票内容")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice.type),
      expression: "invoice.type"
    }],
    staticClass: "bill-list",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.invoice, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("办公用品")]), _vm._v(" "), _c('option', [_vm._v("劳保用品")]), _vm._v(" "), _c('option', [_vm._v("耗材")])])]), _vm._v(" "), _c('div', [_vm._v("发票在您收到货30天后通过平邮寄出，请注意查收")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_vm._v("注：内容不全默认为不索取发票")])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-order",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cOrder.apply(null, arguments)
      }
    }
  }, [_vm._v("提交订单")])])]), _vm._v(" "), _c('address-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAddreModal),
      expression: "isShowAddreModal"
    }],
    attrs: {
      "isShowAddreModal": _vm.isShowAddreModal,
      "getAddressList": _vm.getAddressList
    },
    on: {
      "update:isShowAddreModal": function($event) {
        _vm.isShowAddreModal = $event
      },
      "update:is-show-addre-modal": function($event) {
        _vm.isShowAddreModal = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-nav"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/lc.jpg",
      "alt": "购物车及购物车进程"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod_rel_head clearfix"
  }, [_c('span', {
    staticClass: "mr_tit"
  }, [_vm._v("付款方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aii_labe clearfix"
  }, [_c('b', {
    staticClass: "fl"
  }, [_vm._v("现金券")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aii_labe clearfix"
  }, [_c('b', {
    staticClass: "fl"
  }, [_vm._v("自营购物积分")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-667a7a82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shopping-cart/checkout.vue
// module id = 1622
// module chunks = 1